module.exports = __webpack_public_path__ + "img/missmama-logo.2d3afc33.svg";